import { Participant, ParticipantServerData, TeamType } from './participant';
import { Show } from './show';

export enum RequestToSpeakStatus {
  Pending = 'pending',
  WaitingForPayment = 'waitingForPayment',
  Fulfilled = 'fulfilled',
  Cancelled = 'cancelled',
}

export type RequestToSpeak = {
  id: string;
  bid: number;
  team: TeamType;
  status: RequestToSpeakStatus;
  showId: string;
  participantId: string;
  ephemeralKey?: string;
  stripeCustomerId?: string;
  paymentIntent?: string;
};

export type RequestToSpeakCreateData = {
  bid: number;
  team: TeamType;
  participant: Participant;
};

export type RequestToSpeakServerData = {
  id: string;
  bid: number;
  team: TeamType;
  status: RequestToSpeakStatus;
  show: Show;
  participant: ParticipantServerData;
  ephemeralKey?: string;
  stripeCustomerId?: string;
  paymentIntent?: string;
};

export type RequestToSpeakSocketData = {
  id: string;
  team: TeamType;
  status: RequestToSpeakStatus;
  show: { id: string };
};
